__turbopack_context__.v({
  "caret_prev_icon": "SeeAllVideosWithAudioDescription-module-scss-module__EvssRW__caret_prev_icon",
  "video_audio_description": "SeeAllVideosWithAudioDescription-module-scss-module__EvssRW__video_audio_description",
});
